import { render } from "./ViewPrint.vue?vue&type=template&id=47fbf712"
import script from "./ViewPrint.vue?vue&type=script&lang=js"
export * from "./ViewPrint.vue?vue&type=script&lang=js"

import "./ViewPrint.vue?vue&type=style&index=0&id=47fbf712&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__